<template>
  <div class="card card-body loan-type-details-page">
    <div v-if="loanType">

      <!-- =======================
          HEADER
      ======================== -->
      <section class="mb-4 text-center">
        <h3 class="text-primary font-weight-bold">{{ loanType.name || '—' }}</h3>
        <p class="text-muted mb-0">
          Max Term: {{ loanType.maxTerm || '—' }} {{ loanType.termUnit || 'Weeks' }}
        </p>
        <p class="text-muted">
          Classification: {{ loanType.classification || '—' }}
        </p>
      </section>

      <!-- =======================
          GENERAL INFORMATION
      ======================== -->
      <section class="mb-4">
        <h5 class="text-primary border-bottom pb-2 mb-3">General Information</h5>
        <b-row>
          <b-col md="6" class="mb-2">
            <strong>Description:</strong>
            <div class="text-muted">{{ loanType.description || '—' }}</div>
          </b-col>
          <b-col md="6" class="mb-2">
            <strong>Category ID:</strong>
            <div class="text-muted">{{ loanType.productCategoryId || '—' }}</div>
          </b-col>
          <b-col md="6" class="mb-2">
            <strong>Min Amount:</strong>
            <div class="text-muted">{{ formatAmount(loanType.minAmount) }}</div>
          </b-col>
          <b-col md="6" class="mb-2">
            <strong>Max Amount:</strong>
            <div class="text-muted">{{ formatAmount(loanType.maxAmount) }}</div>
          </b-col>
        </b-row>
      </section>

      <!-- =======================
          CUSTOM ATTRIBUTES / CHARGES
      ======================== -->
      <section class="mb-4" v-if="loanType.customAttributes?.length">
        <h5 class="text-primary border-bottom pb-2 mb-3">Custom Charges / Attributes</h5>

        <b-table
          :items="loanType.customAttributes"
          :fields="attributeFields"
          small
          striped
          responsive
          :empty-text="'No custom attributes found.'"
        >
          <template #cell(value)="data">
            <span v-if="data.item.isPercentage">
              {{ formatAmount(data.item.value) }} <span class="badge bg-info ms-1">%</span>
            </span>
            <span v-else>
              {{ formatAmount(data.item.value) }} <span class="badge bg-info ms-1">Value</span>
            </span>
          </template>

          <template #cell(chargeType)="data">
            {{ data.item.chargeType || '—' }}
            <span v-if="data.item.chargeType === 'One-Time' && data.item.oneTimeTiming === 'Immediately'"
              class="badge bg-info ms-1">Immediately</span>
            <span v-if="data.item.chargeType === 'One-Time' && data.item.oneTimeTiming === 'After Period'"
              class="badge bg-info ms-1">After {{ data.item.oneTimePeriodValue || '—' }} {{ data.item.oneTimePeriodUnit || '' }}</span>
            <span v-if="data.item.chargeType === 'Periodically'"
              class="badge bg-info ms-1">Every {{ data.item.oneTimePeriodValue || '—' }} {{ data.item.oneTimePeriodUnit || '' }}</span>
          </template>
        </b-table>
      </section>

      <!-- =======================
          EDIT BUTTON
      ======================== -->
      <div class="text-end mt-4">
        <button class="btn btn-primary" @click="editLoanType">
          <i class="bi bi-pencil-square me-2"></i>Edit Product Definition
        </button>
      </div>

    </div>

    <div v-else class="text-center py-5 text-muted">
      <b-spinner small class="me-2" /> Loading product details...
    </div>
  </div>
</template>

<script>
export default {
  name: "LoanTypeDetailsPage",
  data() {
    return {
      loanType: null,
      attributeFields: [
        { key: "name", label: "Attribute Name" },
        { key: "chargeType", label: "Charge Type" },
        { key: "value", label: "Value" }
      ]
    };
  },
  created() {
    const saved = localStorage.getItem("loanTypeToView");
    try {
      this.loanType = saved ? JSON.parse(saved) : null;
    } catch {
      this.loanType = null;
    }
  },
  methods: {
    formatAmount(val) {
      if (val == null || val === "") return "—";
      return Number(val).toLocaleString(undefined, { minimumFractionDigits: 2 });
    },
    editLoanType() {
      if (this.loanType?.id) {
        this.$router.push({
          name: "Entry",
          params: { id: this.loanType.id },
          query: { menu: "New Product Definition" }
        });
      } else {
        console.warn("No loan type ID provided for edit. Navigating to new form.");
        this.$router.push({ name: "Entry", query: { menu: "New Product Definition" } });
      }
    }
  }
};
</script>

<style scoped>
.text-primary.border-bottom {
  border-color: #007bff !important;
}
</style>
